import { render, staticRenderFns } from "./TaxPaymentForm.vue?vue&type=template&id=b8f5573a&scoped=true"
import script from "./TaxPaymentForm.vue?vue&type=script&lang=js"
export * from "./TaxPaymentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5573a",
  null
  
)

export default component.exports